import React from "react";
import type { IIntegrationFormImplProps } from "src/integrations/forms/IIntegrationFormImplProps";
import { ShopifyIsPostCheckoutSubscribe } from "src/integrations/forms/shopify/inputs/ShopifyIsPostCheckoutSubscribe";
import { ShopifyIsRestrictedInput } from "src/integrations/forms/shopify/inputs/ShopifyIsRestrictedInput";
import { IntegrationFormShopify } from "src/integrations/forms/shopify/IntegrationFormShopify";

export const IntegrationFormShopifyCheckout = (
  props: IIntegrationFormImplProps,
) => {
  return (
    <IntegrationFormShopify {...props}>
      <ShopifyIsRestrictedInput {...props} />
      <ShopifyIsPostCheckoutSubscribe {...props} />
    </IntegrationFormShopify>
  );
};
